import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import FieldRow from './FieldRow'
import FormikInputField from '../../../../components/Formik/FormikInputField'
import FormikPhoneNumberField from '../../../components/Form/FormikPhoneNumberField'
import { formatMultipleEmailAddresses } from '../../../../helpers/regexHelper'

type Props = {
    /** Natural persons have a mobile number; legal persons only a landline. */
    showMobile?: boolean
}

/**
 * Phone number(s) + e-mail of a party. The e-mail field accepts multiple `;`-separated addresses and
 * normalises them on blur; validation (per address) lives in the party validation schema (HAM-3606).
 */
export default function ContactSection(props: Props): ReactElement {
    const { t: translate } = useTranslation()
    const { setFieldValue } = useFormikContext<any>()

    return (
        <>
            <FieldRow template={props.showMobile ? '1fr 1fr' : undefined}>
                {props.showMobile && <FormikPhoneNumberField label={translate('party.edit.contact.phonemobile')} fieldName="phoneMobile" />}
                <FormikPhoneNumberField label={translate('party.edit.contact.phonelandline')} fieldName="phoneLandline" />
            </FieldRow>
            <FormikInputField<any>
                labelKey="party.edit.contact.email"
                fieldName="email"
                componentProps={{
                    onBlur: (e: React.FocusEvent<HTMLInputElement>) =>
                        setFieldValue('email', formatMultipleEmailAddresses(e.target.value)?.join(';')),
                }}
            />
        </>
    )
}
